export const dbTabs2 = {
  ageRules: {
    heading: "Règles pour les voyageurs",
    headHint:
      "Définissez qui est considéré comme un bébé, un enfant ou un adulte et comment ils sont comptabilisés dans la capacité {scope}. Par défaut, les bébés n'occupent pas de place et ne sont pas facturés.",
    scopeHotel: "de chaque chambre",
    scopeApartment: "du logement",
    loading: "Chargement des règles…",
    emptyHotel: "Cet hôtel n'a aucune chambre configurée.",
    capacityChipTitle: "Capacité de la chambre (définie dans Capacité)",
    slots: "{count} place | {count} places",
    badgeCustom: "Personnalisé",
    badgeStandard: "Standard",
    applyAgeRules: "Appliquer les règles d'âge",
    masterSubHotel: "Bébés, enfants et capacité personnalisés pour cette chambre.",
    masterSubApartment: "Bébés, enfants et capacité personnalisés pour ce logement.",
    standardNote:
      "Comportement standard : les bébés ne sont pas comptabilisés dans la capacité et ne sont pas facturés.",
    capacityLabel: "Capacité",
    capacityGuestsNote:
      'voyageur · défini dans "Capacité" ; ces règles ajustent uniquement qui est comptabilisé | voyageurs · défini dans "Capacité" ; ces règles ajustent uniquement qui est comptabilisé',
    infantUpTo: "Les bébés ont jusqu'à",
    years: "ans",
    childToAdult: "Un enfant devient adulte à",
    maxInfants: "Nombre maximum de bébés",
    perBooking: "par réservation",
    infantsOccupy: "Les bébés occupent une place",
    infantsCharged: "Les bébés sont facturés",
    childrenCount: "Les enfants comptent comme un voyageur",
    ageLegend:
      "Bébé : moins de {infant} ans · Enfant : {infant}–{childTo} ans · Adulte : {adult}+ ans.",
    listingCapacity: "Capacité de l'annonce",
    listingCapacityHint: 'Défini dans "Capacité" et partagé avec "Occupation".',
    thisAccommodation: "Ce logement",
    loadError: "Impossible de charger les règles pour les voyageurs.",
    saveSuccess: "Règles pour les voyageurs enregistrées avec succès.",
    saveError: "Impossible d'enregistrer les règles pour les voyageurs.",
  },
  globalPayments: {
    title: "Paiements globaux (Appartements/Villas)",
    pill: "Global",
    desc: "Ce paramètre s'applique à tous les appartements/villas de l'utilisateur.",
    loading: "Chargement des paramètres…",
    paymentType: "Type de paiement",
    onArrivalLabel: "Paiement à l'arrivée",
    onArrivalDesc: "Le voyageur réserve et paie directement à l'arrivée.",
    onlineLabel: "Paiement en ligne",
    onlineDesc: "Le voyageur paie en ligne au moment de finaliser la réservation.",
    savedAtUserLevel: "Enregistré au niveau de l'utilisateur pour les appartements/villas.",
    globalDiscount: "Remise globale",
    enableGlobalDiscount: "Activer la remise globale",
    discountType: "Type de remise",
    percentageLabel: "Pourcentage",
    percentageDesc: "Remise proportionnelle au total.",
    fixedLabel: "Fixe",
    fixedDesc: "Montant fixe à déduire.",
    valueTitle: "Valeur",
    phPercentage: "ex. 10",
    phFixed: "ex. 15.00",
    helpPercentage: "Jusqu'à 100 %. Appliquée au total.",
    helpFixed: "Un montant fixe en {currency} est déduit.",
    previewTitle: "Aperçu",
    previewPercentage: "Une remise globale de {percent} % sera appliquée.",
    previewFixed: "Une remise globale de {amount} sera appliquée.",
    appliesAllDirect: "S'applique à toutes les réservations directes pour les appartements/villas.",
    saveSuccess: "Paiements globaux enregistrés.",
    saveError: "Impossible d'enregistrer les paiements globaux.",
  },
  payments: {
    loading: "Chargement des paramètres…",
    q02Title: "Quand le voyageur paie-t-il ?",
    savingBadge: "Enregistrement…",
    payOnArrivalName: "Paiement à l'arrivée",
    payOnArrivalHint: "Le voyageur réserve et paie directement à l'arrivée.",
    payOnlineName: "Paiement en ligne",
    payOnlineHint: "Le voyageur paie en ligne au moment de finaliser la réservation.",
    q03Title: "Délai de paiement",
    onlineOnlyBadge: "Paiement en ligne uniquement",
    holdDesc:
      "Le calendrier est bloqué pendant que le voyageur effectue le paiement.<br>S'il ne paie pas dans le délai fixé, <strong>la disponibilité est libérée automatiquement</strong>.",
    unitMin: "min",
    unitHour: "heure",
    unitHours: "heures",
    q04Title: "Paiement partiel",
    partialTitle: "Autoriser le paiement d'une partie seulement à la réservation",
    partialOnDesc:
      "<strong>Activé.</strong> Le voyageur peut payer <strong>{percent} %</strong> maintenant et le reste avant l'arrivée (ou payer la totalité).",
    partialOffDesc:
      "<strong>Désactivé.</strong> Le voyageur paie la <strong>totalité</strong> à la réservation.",
    blockTitle: "Le reste est payé au logement",
    blockOnDesc:
      "<strong>Activé.</strong> Le voyageur paie <strong>seulement {percent} %</strong> en ligne ; le reste est réglé <strong>à l'arrivée</strong> (il ne peut pas payer la totalité en ligne).",
    blockOffDesc:
      "<strong>Désactivé.</strong> Le voyageur peut choisir de payer {percent} % ou la totalité en ligne.",
    q05Title: "Rappel de solde",
    reminderTitle: "Envoyer un rappel pour payer le solde restant",
    reminderOnDesc:
      "<strong>Activé.</strong> <strong>{when}</strong> l'arrivée (vers 09h00, heure de l'établissement), un lien est envoyé au voyageur pour payer le solde restant par <strong>WhatsApp et e-mail</strong>.",
    reminderOffDesc:
      "<strong>Désactivé.</strong> Le voyageur ne reçoit pas de rappel pour payer le solde en ligne avant l'arrivée.",
    daysBefore: "{count} jour avant | {count} jours avant",
    reminderDaysLabel: "Jours avant l'arrivée",
    reminderHint:
      "Envoyé une seule fois, et uniquement aux voyageurs ayant un solde restant. Si le reste est payé au logement, il n'est pas envoyé.",
    approveTitle: "Approuver les réservations",
    approveCardTitle: "Approuver chaque réservation avant sa confirmation",
    approveOnDesc:
      "<strong>Activé.</strong> Chaque réservation reste <strong>en attente de votre approbation</strong> : vous recevez une notification et décidez de l'accepter ou de la refuser. Elle n'est pas confirmée tant que vous ne l'avez pas approuvée.",
    approveOffDesc:
      "<strong>Désactivé.</strong> Les réservations <strong>se confirment automatiquement</strong> une fois le paiement effectué. Activez cette option si vous préférez examiner et approuver chaque demande vous-même.",
    saveSuccess: "Enregistré.",
    saveError: "Impossible d'enregistrer les modifications.",
  },
  unitConfig: {
    descByRoom: "Description par chambre",
    descByRoomHint:
      "Chaque chambre possède sa propre description et sa propre visibilité dans la réservation directe.",
    loadingRooms: "Chargement des chambres…",
    emptyHotel: "Cet hôtel n'a aucune chambre configurée.",
    visible: "Visible",
    hidden: "Masqué",
    roomDescPlaceholder: "Décrivez {name} (lits, équipements, vues…)",
    savingDesc: "Enregistrement…",
    autosaveHint: "Enregistré automatiquement lorsque vous quittez le champ.",
    loadingProperty: "Chargement des données du logement…",
    loadErrorProperty: "Impossible de charger les paramètres de ce logement.",
    amenitiesByRoom: "Équipements par chambre",
    amenitiesByRoomHint:
      "Chaque chambre peut proposer des équipements différents. La réservation directe et l'agent IA utilisent ceux de la chambre attribuée au voyageur.",
    amenitiesCount: "{count} équipement | {count} équipements",
    noAmenities: "Aucun équipement",
    titleDescription: "Description du logement",
    titleServices: "Équipements et commodités",
    subtitleDescription:
      "Modifiez la description que les voyageurs verront sur votre page de réservation directe.",
    subtitleServices: "Indiquez ce que propose ce logement et ajoutez ses photos.",
  },
};
